var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.7359,
    y1: 219.6922,
    x2: 662.6459,
    y2: -18.3279,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8DE6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8AA753"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M453.384,20.5l58.354,381.648c1.887,12.344-6.599,23.894-18.943,25.782l-381.648,58.354 c-12.344,1.887-23.894-6.599-25.782-18.943L27.011,85.693c-1.887-12.344,6.599-23.894,18.943-25.782L427.602,1.557 C439.946-0.33,451.496,8.156,453.384,20.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.3236,
    y1: 198.6866,
    x2: 627.2736,
    y2: -63.1735,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7695"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE547B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M457.455,50.956l29.261,384.973c0.947,12.452-8.391,23.325-20.842,24.272L80.901,489.462 c-12.452,0.947-23.325-8.391-24.272-20.842L27.368,83.647c-0.947-12.452,8.391-23.325,20.842-24.272l384.973-29.261 C445.635,29.167,456.509,38.504,457.455,50.956z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.369,
    y1: 178.9728,
    x2: 588.5989,
    y2: -105.2572,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67DCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#019394"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M459.207,81.633v386.083c0,12.488-10.135,22.622-22.622,22.622H50.502 c-12.488,0-22.622-10.135-22.622-22.622V81.633c0-12.488,10.135-22.622,22.622-22.622h386.083 C449.073,59.01,459.207,69.146,459.207,81.633z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.5151,
    y1: 284.5429,
    x2: 228.5151,
    y2: -203.4571,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCC344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7AE3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M314.922,510.62L20.926,488.501c-12.459-0.938-21.798-11.797-20.861-24.256L29.029,79.25 c0.938-12.459,11.797-21.798,24.256-20.861l384.996,28.964c12.459,0.938,21.798,11.797,20.862,24.256L436.58,411.51 c-0.26,3.452-1.867,6.663-4.474,8.94l-94.716,82.691C331.202,508.541,323.11,511.235,314.922,510.62z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.864,
    y: 201.706,
    transform: "matrix(-0.9971 -0.0756 0.0756 -0.9971 467.3999 446.2027)",
    style: {
      fill: "#FFF2EB"
    },
    width: 334.564,
    height: 25.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.035,
    y: 265.406,
    transform: "matrix(-0.9971 -0.0756 0.0756 -0.9971 452.9404 573.0537)",
    style: {
      fill: "#FFF2EB"
    },
    width: 334.564,
    height: 25.096
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.323,
    y: 325.808,
    transform: "matrix(-0.9971 -0.0756 0.0756 -0.9971 352.1519 690.0431)",
    style: {
      fill: "#FFF2EB"
    },
    width: 247.628,
    height: 25.096
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.4758,
    y1: 54.4429,
    x2: 184.4758,
    y2: 7.3929,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCC344",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D48000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M337.387,503.141l33.394-29.155L1.423,446.199l-1.357,18.047 c-0.908,12.063,7.835,22.638,19.703,24.138c0.382,0.048,0.769,0.087,1.159,0.116l293.995,22.118 C323.11,511.235,331.202,508.541,337.387,503.141z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.8396,
    y1: 71.3947,
    x2: 424.2696,
    y2: -7.0052,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCC344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D48000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M435.019,416.811c0,0-0.808,1.838-3.63,4.265c-1.048,0.902-93.444,81.58-93.444,81.58 c-6.542,5.711-15.1,8.559-23.76,7.908l0,0l0,0c7.475,0.562,13.991-5.042,14.553-12.517l4.978-66.171 c0.938-12.459,11.797-21.798,24.256-20.861L435.019,416.811z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/icon-notes.f4268c274c7550996743b1894159a1f5.svg";
export { ForwardRef as ReactComponent };